import { render, staticRenderFns } from "./DetailArea.vue?vue&type=template&id=0f2740ee&scoped=true&"
import script from "./DetailArea.vue?vue&type=script&lang=js&"
export * from "./DetailArea.vue?vue&type=script&lang=js&"
import style0 from "./DetailArea.vue?vue&type=style&index=0&id=0f2740ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2740ee",
  null
  
)

export default component.exports